import { Injectable } from '@angular/core';
import { StatoFascicoloConfiguration, StatoPraticaConfiguration } from '../configuration/stato-entita-configuration';

@Injectable()
export abstract class FascicoloPraticaUtil {

  isFascicoloInLavorazione(fascicolo): boolean {
    let result = false;
    if (fascicolo && fascicolo.stato && fascicolo.stato.id === StatoFascicoloConfiguration.IN_LAVORAZIONE) {
      result = true;
    }
    return result;
  }

  isFascicoloToComplete(fascicolo): boolean {
    let result = false;
    if (fascicolo && fascicolo.stato && fascicolo.stato.id === StatoFascicoloConfiguration.DA_COMPLETARE) {
      result = true;
    }
    return result;
  }

  isFascicoloInSmistamento(fascicolo): boolean {
    let result = false;
    if (fascicolo && fascicolo.stato && fascicolo.stato.id === StatoFascicoloConfiguration.IN_SMISTAMENTO) {
      result = true;
    }
    return result;
  }

  isFascicoloInAssegnazione(fascicolo): boolean {
    let result = false;
    if (fascicolo && fascicolo.stato && fascicolo.stato.id === StatoFascicoloConfiguration.IN_ASSEGNAZIONE) {
      result = true;
    }
    return result;
  }

  isFascicoloInAssegnazioneLegale(fascicolo): boolean {
    let result = false;
    if (fascicolo && fascicolo.stato && fascicolo.stato.id === StatoFascicoloConfiguration.IN_ASSEGNAZIONE_LEGALE) {
      result = true;
    }
    return result;
  }

  isFascicoloBozza(fascicolo): boolean {
    let result = false;
    if (fascicolo && fascicolo.stato && fascicolo.stato.id === StatoFascicoloConfiguration.BOZZA) {
      result = true;
    }
    return result;
  }

  isFascicoloDefinito(fascicolo): boolean {
    let result = false;
    if ((fascicolo && fascicolo.stato && fascicolo.stato.id === StatoFascicoloConfiguration.DEFINITO) || (fascicolo && fascicolo.definito)) {
      result = true;
    }
    return result;
  }

  isFascicoloRiunito(fascicolo): boolean {
      let result = false;
      if (fascicolo && fascicolo.stato && fascicolo.stato.id === StatoFascicoloConfiguration.RIUNITO) {
        result = true;
      }
      return result;
    }

  isFascicoloArchiviato(fascicolo): boolean {
    let result = false;
    if (fascicolo && fascicolo.stato && fascicolo.stato.id === StatoFascicoloConfiguration.ARCHIVIATO) {
      result = true;
    }
    return result;
  }

  isPraticaBozza(pratica): boolean {
    let result = false;
    if (pratica && pratica.stato && pratica.stato.id === StatoPraticaConfiguration.BOZZA) {
      result = true;
    }
    return result;
  }

  isPraticaPendente(pratica): boolean {
    let result = false;
    if (pratica && pratica.stato && pratica.stato.id === StatoPraticaConfiguration.PENDENTE) {
      result = true;
    }
    return result;
  }

  isPraticaArchiviata(pratica): boolean {
    let result = false;
    if (pratica && pratica.stato && pratica.stato.id === StatoPraticaConfiguration.ARCHIVIATA) {
      result = true;
    }
    return result;
  }

  isPraticaRiunita(pratica): boolean {
    let result = false;
    if (pratica && pratica.riunita) {
      result = true;
    }
    return result;
  }
}

